// extracted by mini-css-extract-plugin
export var chevronIcon = "_dk-2";
export var teamName = "_dk-1";
export var teamSwitcherButton = "_dk-0";